import imgempresahome from '../../assets/images/img-home-PJ@2x.png';
import { Link } from 'react-router-dom';
import useScreenSize from '../../hooks/useScreenSize';
import { useEffect, useState } from 'react';
import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
const produtos = [
    (<div className='info-container black'>
        <div>
            <h1> Produtos de proteção</h1>
            <h2>
                Oferecemos produtos de hedge cambial para total
                proteção de suas transações. Temos como vantagens
                uma equipe de tesouraria dedicada, com exigência
                reduzida de chamada de margem além de um menor
                custo de EPF.
            </h2>
            <Link className='info-button' to={"/produtos-de-protecao"}> Ver produtos </Link>
        </div>
    </div>),
    (
        <div className='info-container gray'>
                        <div>
                            <h1>Câmbio pronto</h1>
                            <h2>
                                Transações de câmbio para qualquer natureza.
                                Usamos a tecnologia de ponta sem abrir mão
                                de um atendimento humanizado. Para nós, cada
                                cliente é único e criamos soluções personalizadas
                                diante as suas necessidades.
                            </h2>
                            <Link className='info-button' to={"/cambio-pronto"}> Ver produtos </Link>
                        </div>
                    </div>
    ),
    (
        <div className='info-container gray'>
                        <div>
                            <h1>Produtos de crédito</h1>
                            <h2>
                                Temos uma diversidade de produtos
                                específicos para o mercado cambial
                                além de apetite para operações de
                                maiores complexidades. As aprovações
                                de crédito são ágeis e as exigências de
                                garantia são reduzidas.
                            </h2>
                            <Link className='info-button' to={"/produtos-de-credito"}> Ver produtos </Link>
                        </div>
                    </div>
    ),
    (
        <div className='info-container black'>
        <div>
            <h1>Produtos exclusivos</h1>
            <h2>
                Falamos com clientes todos os dias e ouvimos
                suas dores e necessidades. Por isso, voltamos
                nossos olhares para problemas operacionais e
                não somente transações de câmbio pura e
                simplesmente.
            </h2>
            <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" className='info-button'> Fale com um especialista </a>
        </div>
    </div>  
    )
]


export const ParaSuaEmpresa = () => {
    const size = useScreenSize();
    const [swipeLayout, setSwipeLayout] = useState(false)

    useEffect(() => {
        setSwipeLayout(size.width < 900)
    },[size])

    return (

        <div className='container-page4' >

            <div className={`container-1-page4 ${swipeLayout? "empresaBG" : ""}`} >
                <h1> [ Para sua empresa ] </h1>
                <h2> Expertise de mercado aliada à múltiplos players liquidantes </h2>
                <p>
                    Executamos com perfeição suas operações de acordo com as suas
                    necessidades e particularidades do segmento de mercado.
                </p>
            </div>
            <div className='container-2-page4'>
            {swipeLayout? 
             <Swiper

             modules={[Pagination, Autoplay]}
             autoplay={{ delay: 4500 }}
             pagination
             loop
         >
             {produtos.map(slides => (
                 <SwiperSlide>
                    <div className='info-column'>
                        {slides}
                    </div>
                 </SwiperSlide>
             ))}

            </Swiper>
            :

                <>

                    <div className='info-column'>
                    {produtos[0]}
                    {produtos[1]}
                    </div>
                    <div className='info-image'>
                        <img src={imgempresahome} alt="Sua Empresa" />
                    </div>
                    <div className='info-column'>
                        {produtos[2]}
                        {produtos[3]}
                    </div>

                
                </> 
                
            }
            </div>

        </div>

    )

}
